<template>
    <div>
        <b-form-group label-align="right" :label="$t('Enterprise ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input  type="number" v-model="Option125.Enterprise"/>
        </b-form-group>
        <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Force Add')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-checkbox switch v-model="Option125.Flag"></b-checkbox>
        </b-form-group>

        <b-form-group style="margin-left:3%;margin-top:7%" :label="$t('Suboption:')">
            <b-form-group  label-align="right" :label="$t('Suboption ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input  type="number" v-model="SubOpt.ID"/>
            </b-form-group>
            <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-select  :options="dhcpOptsTypes" type="text" v-model="SubOpt.Type"/>
            </b-form-group>
            <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input  type="text" v-model="SubOpt.Data"/>
            </b-form-group>

            <md-button style="margin-left:80%;margin-top:-2%" class="md-raised" @click="addSubOption" >{{ $t('Add') }}</md-button>
            <b-table striped hover small
                :items="Option125.SubOpts"
                :fields="OptionsFields">
                <template v-slot:cell(actions)="row">
                    <i @click.stop="ClickOnDeleteOptsButton(row)" class="danger fa fa-trash-alt fa-lg" />
                </template>
            </b-table>
        </b-form-group>
    </div>
</template>

<script>
export default {
  data () {
    return {
      OptionsList: [],
      dhcpOptsTypes: [ this.$i18n.t('Number(16)'),
        this.$i18n.t('Number(32)'),
        this.$i18n.t('String'),
        this.$i18n.t('IP address'),
        this.$i18n.t('Binary')
      ],
      OptionsFields: [
        {key: 'ID', label: this.$i18n.t('Suboption ID'), sortable: true},
        {key: 'Data', label: this.$i18n.t('Value'), sortable: true},
        {key: 'Type', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      Option125: {
        Enterprise: 0,
        Len: 0,
        Flag: false,
        SubOpts: []
      },
      SubOpt: {
        ID: 0,
        Len: 0,
        Data: '',
        Type: 0
      }
    }
  },
  methods: {
    addHexZeroPad (hex) {
      let res = hex
      if (hex.length % 2 === 1) {
        res = '0' + hex
      }
      return res
    },
    getOption125 () {
      let opt125 = this.Option125
      let opt125Val = 'Enterprise: ' + opt125.Enterprise + '\n'
      const hexEnterpriseID = Number(opt125.Enterprise).toString(16).padStart(8, '0')
      let hexValue = hexEnterpriseID
      let subOptsLen = 0
      let subOptsHex = ''
      for (let subOpt of opt125.SubOpts) {
      // Len valueLen + 2 (supOptID + subOptLen)
        // Subopt ID
        subOptsHex = subOptsHex + this.addHexZeroPad(subOpt.ID.toString(16))
        opt125Val = opt125Val + 'SuboptID: ' + subOpt.ID + '\n'

        // // Hex value
        switch (subOpt.Type) {
          case this.$i18n.t('Number(32)'):
            subOptsLen = subOptsLen + 4 + 2
            let hexNum = Number(subOpt.Data).toString(16)
            // Hex value len Number integer(4 byte = 8 hexDigit)
            subOptsHex = subOptsHex + (Number(4)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + hexNum.padStart(8, '0')
            break
          case this.$i18n.t('String'):
            subOptsLen = subOptsLen + Number(subOpt.Data.length) + 2
            // Hex value len
            subOptsHex = subOptsHex + subOpt.Data.length.toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + Buffer.from(String(subOpt.Data)).toString('hex')
            break
          case this.$i18n.t('IP address'):
            subOptsLen = subOptsLen + 4 + 2
            let ipHex = ''
            subOpt.Data.split('.').forEach(byte => { ipHex = ipHex + Number(byte).toString(16).padStart(2, '0') })
            subOptsHex = subOptsHex + (Number(4)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + ipHex
            break
          case this.$i18n.t('Binary'):
            subOptsLen = subOptsLen + Number(subOpt.Data.length / 2) + 2
            // Hex value len 2hex = 1 byte
            subOptsHex = subOptsHex + (subOpt.Data.length / 2).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + subOpt.Data
            break
          case this.$i18n.t('Number(16)'):
            subOptsLen = subOptsLen + 2 + 2
            let hexNum16 = Number(subOpt.Data).toString(16)
            // Hex value len 2hex = 1 byte , 2 Byte
            subOptsHex = subOptsHex + (Number(2)).toString(16).padStart(2, '0')
            subOptsHex = subOptsHex + hexNum16.padStart(4, '0')
            break
        }
        opt125Val = opt125Val + 'Subopt value: ' + subOpt.Data + '\n'
      }
      // sub opts len
      hexValue = hexValue + subOptsLen.toString(16).padStart(2, '0')
      // sub opts binary value
      hexValue = hexValue + subOptsHex
      let tmpOpt = {}
      tmpOpt.type = this.$i18n.t('Binary')
      tmpOpt.option_id = 125
      tmpOpt.value = hexValue
      tmpOpt.flag = opt125.Flag
      let opt = {option_id: 125, value: opt125Val, type: this.$i18n.t('Binary'), flag: opt125.Flag}
      return {optEl: opt, opt125: tmpOpt}
    },
    ClickOnDeleteOptsButton (row) {
      this.Option125.SubOpts = this.Option125.SubOpts.filter(function (value) {
        return value !== row.item
      })
    },
    addSubOption () {
      let copy = JSON.parse(JSON.stringify(this.SubOpt))
      this.Option125.SubOpts.push(copy)
    },
    getOption () {
      return this.Option125
    },
    parseOpt125Value (val, flag_) {
      let res = 'Enterprise : '
      let EnterpriseID = val.slice(0, 8)
      res = res + parseInt(EnterpriseID, 16)
      let l = val.slice(8, 10)
      res = res + ' Length: ' + parseInt(l, 16)
      let currentIndx = 0
      let subOpts = val.slice(10)
      while (subOpts.length > 0) {
        let SOptLen = parseInt(subOpts.slice(2, 4), 16)
        let dataLen = 2 * Number(SOptLen)
        let idAndL = 2 + 2 // id = 1 byte(2 character)  Length = 1 byte
        currentIndx = dataLen + idAndL
        res = res + this.subOpt125Parser(subOpts.slice(0, currentIndx))
        subOpts = subOpts.slice(currentIndx)
      }
      return {option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/option125.vue